<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <!-- Contenet page started-->
  <div class="row">
    <div class="col-md-12">
      <!-- breadcrumb -->
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Reports</a></li>
          <li><a>Farm</a></li>
          <li><a>Payments Report</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
    </div>
    <!-- breadcrumb End -->
    <div class="block">
      <div class="page-header">
        <span class="page-header__title">Payments Report</span>
      </div>
      <div class="Reports_form_div">
        <form class="form-horizontal" id="myForm" role="form" novalidate [formGroup]="registerForm">
          <div class="reports-form-container" (clickOutside)="isDropdownOpen = false">
            <mat-form-field appearance="outline" class="w-100 custom-select" *ngIf="loginPersonType == 'EMPLOYEE'">
              <mat-label>Search Business Name</mat-label>
              <!-- search box powered by mat‑autocomplete -->
              <input matInput type="text" id="businessname" autocomplete="off" formControlName="businessfield"
                     placeholder="Search business" (keyup)="filterBusinesses($event)"
                     (click)="isDropdownOpen = true" (focus)="filteredOptions = businessEntities"
                     [matAutocomplete]="businessAuto"/>
              <mat-autocomplete #businessAuto="matAutocomplete" (optionSelected)="selectOption($event.option.value)">
                <mat-option *ngFor="let option of filteredOptions" [value]="option">
                  {{ option.businessName }}
                </mat-option>
              </mat-autocomplete>
              <mat-hint *ngIf="f.businessfield.invalid"><i>Select business</i></mat-hint>
              <mat-hint *ngIf="f.businessfield.valid"><i>Business selected</i></mat-hint>
              <mat-error *ngIf="(submitted || f.businessfield.touched || f.businessfield.dirty) && f.businessfield.errors">
                <i *ngIf="f.businessfield.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Farm Site</mat-label>
              <mat-select id="location" formControlName="locationField" name="location" (click)="isDropdownOpen = false"
                          [(ngModel)]="paymentTransactionRegister.farm_site_id">
                <mat-option value="undefined" disabled>Select Farm site</mat-option>
                <mat-option *ngFor="let farmsite of farmSites" [value]="farmsite.id">
                  {{ (farmsite?.farmNameAtLocation) }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="f.locationField.invalid"><i>Select farm site</i></mat-hint>
              <mat-hint *ngIf="f.locationField.valid"><i>Farm site selected</i></mat-hint>
              <mat-error *ngIf="(submitted || f.locationField.touched || f.locationField.dirty) && f.locationField.errors">
                <i *ngIf="f.locationField.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
          </div>
        </form>
        <div class="buttons-div reports_search_div">
          <div class="transactions-button-container" (click)="getAllPTRegisterData()">
            <button class="transaction-submit-button" [disabled]="submitButtonDisabled">
              <span class="icon"><img src="../../../../../../assets/images/New_Icons/search-icon.svg"></span>
              <span class="text">Search</span>
            </button>
          </div>
        </div>
      </div>
      <!--loader-->
      <div *ngIf="responseLoader">
        <div class="adjust loader-container">
          <div class="loader2"></div>
        </div>
      </div>
      <!--loaderend-->
      <!-- START BASIC TABLE SAMPLE -->
    </div>
    <div class="block">
      <div class="reports_block" *ngIf="!responseLoader && isSubmitClicked">
        <div class="reports-toolbar">
          <!-- Search -->
          <div class="reports-toolbar__search">
            <img src="assets/images/New_Icons/search-icon.svg" alt="Search Icon" />
            <input type="text" (keyup)="onFiltersApplied()" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by vendor name and vendor site"/>
            <button *ngIf="search !== ''" type="button" (click)="clearFilters('search')" class="reports-toolbar__clear-btn" style="top: 10px" title="Clear search">&times;</button>
          </div>
          <!-- Filters -->
          <div class="reports-toolbar__select-wrapper">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Filter by Date Range</mat-label>
              <mat-date-range-input [rangePicker]="picker" [formGroup]="dateRangeForm" [max]="maxDate" (focus)="picker.open()" (click)="picker.open()">
                <input matStartDate placeholder="Start date" formControlName="start" readonly />
                <input matEndDate placeholder="End date" formControlName="end" readonly />
              </mat-date-range-input>
              <!-- Dynamic icon: calendar or clear (×) -->
              <button mat-icon-button matSuffix [ngClass]="dateFilterApplied ? 'reports-toolbar__clear-btn' : ''"
                      [ngStyle]="{ 'z-index': 1000, 'position': 'relative', 'background': 'none', 'border': 'none', 'box-shadow': 'none', 'outline': 'none'}"
                      (click)="dateFilterApplied ? clearDateRange() : picker.open()"
                      aria-label="Toggle date">
                <!-- Show normal calendar icon if no filter applied -->
                <mat-icon *ngIf="!dateFilterApplied">calendar_today</mat-icon>
                <!-- Show × if filter is applied -->
                <span *ngIf="dateFilterApplied" style="font-size: 20px; font-weight: bold;">&times;</span>
              </button>
              <mat-date-range-picker #picker (closed)="onPickerClosed()"></mat-date-range-picker>
            </mat-form-field>
          </div>
          <!-- Actions -->
          <div class="reports-toolbar__actions" *ngIf="paymentTransactionRegisters?.length > 0">
            <img src="assets/images/New_Icons/excel-download-icon.svg" title="Excel export" (click)="exportExcel()" />
            <img src="assets/images/New_Icons/expand-icon.svg" title="Zoom In" (click)="openFullScreen()"/>
          </div>
        </div>
        <div class="table-responsive" id="zoomView" *ngIf="paymentTransactionRegisters?.length > 0">
          <table class="table table-bordered table-responsive-md table-striped">
            <thead>
            <tr>
              <th>S.No</th>
              <th class="handSymbol" (click)="sortingPTRegister('vname')">Vendor Name
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':nameAsc,'glyphicon-chevron-down':!nameAsc}"></span>
              </th>
              <th class="handSymbol" (click)="sortingPTRegister('vsite')">Vendor Site
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':vsiteAsc,'glyphicon-chevron-down':!vsiteAsc}"></span>
              </th>
              <th>Date</th>
              <th>Amount</th>
              <th>Towards</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let list of paymentTransactionRegisters; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ (list && list.Vendor == null) ? 'NA' : (list && list.Vendor && list.Vendor.name) }}</td>
              <td>{{ (list && list.Vendor == null) ? 'NA' : (list && list.Vendor && list.Vendor.site) }}</td>
              <td>{{ (list && list.date == null) ? 'NA' : list && list.date | date : "dd MMM yyyy" }}</td>
              <td *ngIf="list && list.paid_amount != 0" class="number-align-right">{{ list && list.paid_amount | currencyFormat }}</td>
              <td *ngIf="list && list.return_amount != 0" class="number-align-right">{{ list && list.return_amount | currencyFormat }}</td>
              <td *ngIf="list && list.paid_amount != 0">Paid</td>
              <td *ngIf="list && list.return_amount != 0">Return</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="listLoader" class="loader-div">
          <div class="adjust">
            <div class="loader2 list-loader"></div>
          </div>
        </div>
        <!-- Show message only when search or date filter is applied and no results found -->
        <div *ngIf="paymentTransactionRegisters?.length <= 0 && isSubmitClicked && (search || dateFilterApplied)" class="noDataFoundMessage">
          {{ search && dateFilterApplied ? 'No items match your search and filter' :
          (search ? 'No items match your search' : 'No items match your filter') }}
        </div>

      </div>
      <!-- Show "Data Not Available" only when no results and no search or filter is applied -->
      <div class="reports_block" *ngIf="paymentTransactionRegisters?.length <= 0 && isSubmitClicked && !(search || dateFilterApplied)">
        <div class="noDataFoundMessage">Data Not Available</div>
      </div>

    </div>
  </div>
</div>
